




















import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'

@Component({
  props: ['items']
})
export default class MenuFirstLvl extends Vue {
  setActiveMenu(id: string) {
    vxm.menu.setActiveMenu(id)
  }
}
